import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetActivitiesSummaryByTaskUseCaseInterface } from 'domain/usecases';

interface IActivitiesSummaryByTask {
  activitiesByTask: GetActivitiesSummaryByTaskUseCaseInterface.Result[];
}

interface IPayloadActivitiesSummaryByTask
  extends PayloadAction<GetActivitiesSummaryByTaskUseCaseInterface.Result[]> {}

const initialState: IActivitiesSummaryByTask = {
  activitiesByTask: null,
};

export const ActivitiesSummaryByTaskSlice = createSlice({
  name: 'activities-summary-by-task',
  initialState,
  reducers: {
    loadActivitiesSummaryByTask: (
      state,
      action: IPayloadActivitiesSummaryByTask,
    ) => {
      state.activitiesByTask = action.payload;
    },
    clearActivitiesSummaryByTask: (state) => {
      state.activitiesByTask = null;
    },
  },
});

export const { loadActivitiesSummaryByTask, clearActivitiesSummaryByTask } =
  ActivitiesSummaryByTaskSlice.actions;

export default ActivitiesSummaryByTaskSlice.reducer;
